import { useState } from "react";

interface Props {
  password: string;
  onClose: () => void;
  hint?: string;
}

/**
 * Модалка с одноразовым показом сгенерированного пароля.
 * Пользователь должен скопировать его сейчас — после закрытия больше не показывается.
 */
export function PasswordReveal({ password, onClose, hint }: Props) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard API недоступен — оставим как fallback ручное копирование
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        <h2 className="text-lg font-semibold text-slate-900">Пароль сгенерирован</h2>
        <p className="mt-1 text-sm text-slate-500">
          {hint ?? "Передай пользователю любым удобным способом. Этот пароль больше не показывается."}
        </p>

        <div className="mt-4 rounded-md border border-slate-200 bg-slate-50 p-3 font-mono text-sm tracking-wide text-slate-900">
          {password}
        </div>

        <div className="mt-4 flex items-center justify-between">
          <button
            type="button"
            onClick={handleCopy}
            className="rounded border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-100"
          >
            {copied ? "Скопировано ✓" : "Копировать"}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="btn-primary"
          >
            Готово
          </button>
        </div>
      </div>
    </div>
  );
}
